import Icon from '@/components/ui/AppIcon';

interface TimelineEvent {
  id: string;
  type: 'flight' | 'hotel' | 'activity' | 'transfer';
  title: string;
  time: string;
  location: string;
  status: 'completed' | 'upcoming' | 'current';
  details: string;
}

interface TripTimelineProps {
  events: TimelineEvent[];
}

export default function TripTimeline({ events }: TripTimelineProps) {
  const iconMap = {
    flight: 'PaperAirplaneIcon' as const,
    hotel: 'BuildingOfficeIcon' as const,
    activity: 'MapPinIcon' as const,
    transfer: 'TruckIcon' as const
  };

  const statusColors = {
    completed: 'bg-success text-success-foreground',
    current: 'bg-accent text-accent-foreground',
    upcoming: 'bg-muted text-muted-foreground'
  };

  return (
    <div className="bg-card rounded-xl shadow-brand p-6 border border-border">
      <h3 className="font-heading font-semibold text-lg text-foreground mb-6">
        Trip Timeline
      </h3>

      <div className="space-y-6">
        {events.map((event, index) => (
          <div key={event.id} className="relative">
            {index !== events.length - 1 && (
              <div className="absolute left-5 top-12 bottom-0 w-0.5 bg-border" />
            )}
            
            <div className="flex items-start space-x-4">
              <div className={`w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0 ${statusColors[event.status]}`}>
                <Icon name={iconMap[event.type]} size={20} />
              </div>
              
              <div className="flex-1 pb-6">
                <div className="flex items-start justify-between mb-2">
                  <div>
                    <h4 className="font-heading font-semibold text-foreground">
                      {event.title}
                    </h4>
                    <p className="text-sm text-muted-foreground">{event.location}</p>
                  </div>
                  <span className="text-sm font-medium text-primary">{event.time}</span>
                </div>
                <p className="text-sm text-muted-foreground">{event.details}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}